import { render, staticRenderFns } from "./OptionItem.vue?vue&type=template&id=1a53dfeb&scoped=true"
import script from "./OptionItem.vue?vue&type=script&lang=ts"
export * from "./OptionItem.vue?vue&type=script&lang=ts"
import style0 from "./OptionItem.vue?vue&type=style&index=0&id=1a53dfeb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a53dfeb",
  null
  
)

export default component.exports